import React from "react";

const VARIANT_CLASSES = {
  primary: "btn btn-primary",
  success: "btn btn-success",
  danger: "btn btn-danger",
  warning: "btn btn-warning",
  secondary: "btn btn-secondary",
  cancel: "btn btn-cancel",
  light: "btn btn-light",
  ghost: "btn btn-secondary",
};

const BaseButton = ({
  type = "button",
  label,
  color = "primary",
  loader = false,
  className = "",
  onClick,
  disabled = false,
  children,
  tooltipName,
  icon,
  style = {},
  ...props
}) => {
  const variantClass = VARIANT_CLASSES[color] || `btn btn-${color}`;
  const textColor = color === "secondary" ? "#fff" : undefined;

  return (
    <button
      type={type}
      className={`${variantClass} ${className}`}
      disabled={disabled || loader}
      onClick={onClick}
      title={tooltipName || undefined}
      style={style}
      {...props}
    >
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 6,
          lineHeight: 1,
          pointerEvents: "none",
          ...(textColor ? { color: textColor } : {}),
        }}
      >
        {loader && <span className="ds-spinner ds-spinner-sm" role="status" aria-hidden="true" />}
        {icon}
        {children}
        {label}
      </span>
    </button>
  );
};

export default BaseButton;
